import React from 'react';
import { useTranslation } from '../../i18n';
import { Modal, AvatarSelector } from '../shared';

interface HostJoinAsPlayerModalProps {
  isOpen: boolean;
  playerName: string;
  avatar: string;
  onPlayerNameChange: (name: string) => void;
  onAvatarChange: (avatar: string) => void;
  onClose: () => void;
  onJoin: () => void;
}

export const HostJoinAsPlayerModal: React.FC<HostJoinAsPlayerModalProps> = ({
  isOpen,
  playerName,
  avatar,
  onPlayerNameChange,
  onAvatarChange,
  onClose,
  onJoin,
}) => {
  const { t } = useTranslation();

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      overlayClassName="host-join-as-player-overlay"
      contentClassName="host-join-as-player-modal__content"
      contentStyle={{
        maxWidth: '500px',
        width: '100%',
      }}
    >
      <div className="host-join-as-player-modal">
        <h2 className="host-join-as-player-modal__title">
          {t('lobby.gameSelection.joinAsPlayerTitle')}
        </h2>

        <label className="form-label">{t('common.yourName')}</label>
        <input
          type="text"
          className="input"
          placeholder={t('common.enterYourName')}
          value={playerName}
          onChange={(e) => onPlayerNameChange(e.target.value)}
        />

        <AvatarSelector
          selectedAvatar={avatar}
          onSelect={onAvatarChange}
          label={t('common.chooseAvatar')}
          gridColumns={4}
        />

        <div className="join-room-buttons">
          <button type="button" className="button join-room-back-button" onClick={onClose}>
            {t('common.cancel')}
          </button>
          <button type="button" className="button join-room-button" onClick={onJoin}>
            {t('lobby.gameSelection.joinAsPlayer')}
          </button>
        </div>
      </div>
    </Modal>
  );
};
